import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserCareProgramsService} from '@shared/api/services/v2/user-care-programs.service';
import {UserCareProgramModuleEntry} from '@shared/api/models/query/user-care-program.model';

interface WeekGroup {
    weekNumber: number;
    expanded: boolean;
    modules: UserCareProgramModuleEntry[];
}

@Component({
    selector: 'cdss-full-programme-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './full-programme-modal.component.html',
    styleUrl: './full-programme-modal.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class FullProgrammeModalComponent implements OnInit {

    @Input() careProgramId!: number;
    @Input() patientLabel: string = '';

    weeks: WeekGroup[] = [];
    loading = true;

    constructor(
        public modal: NgbActiveModal,
        private userCareProgramsService: UserCareProgramsService,
    ) {}

    ngOnInit(): void {
        this.userCareProgramsService.getModules(this.careProgramId).subscribe({
            next: (modules) => {
                const map = new Map<number, UserCareProgramModuleEntry[]>();
                for (const entry of modules) {
                    if (!map.has(entry.weekNumber)) map.set(entry.weekNumber, []);
                    map.get(entry.weekNumber)!.push(entry);
                }
                this.weeks = Array.from(map.entries())
                    .sort((a, b) => a[0] - b[0])
                    .map(([weekNumber, mods]) => ({
                        weekNumber,
                        expanded: true,
                        modules: mods.sort((a, b) => a.orderInWeek - b.orderInWeek),
                    }));
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    toggleWeek(week: WeekGroup): void {
        week.expanded = !week.expanded;
        this.weeks = [...this.weeks];
    }

    progressPct(value: number): number {
        return Math.round((value ?? 0) * 100);
    }
}
